// extracted by mini-css-extract-plugin
export default {"notice":"LegalNotice_notice__wgFgc"};